import { render, staticRenderFns } from "./ResSelect.vue?vue&type=template&id=ebf4a3e6&scoped=true"
import script from "./ResSelect.vue?vue&type=script&lang=js"
export * from "./ResSelect.vue?vue&type=script&lang=js"
import style0 from "./ResSelect.vue?vue&type=style&index=0&id=ebf4a3e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebf4a3e6",
  null
  
)

export default component.exports